import Slider from 'react-slick'
import get from 'lodash/get'
import './styles/conservation-events.scss'
import AdventureOriginalTitle from './AdventureOriginalTitle'

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
}

export default function ConservationEvents({ items, region }) {
  if(!get(items, 'length')) {
    return null
  }
  return (
    <Slider className='slick-pt-custom same-height' {...settings}>
      {items.map((item) => (
        <a
          className='events-slider-item'
          href={item.url}
          key={item.title}
          data-navigation-elements='data-navigation-elements'
          data-region-identifier={region}
        >
          <div className='events-slider-item__image-container'>
            <img src={item.image} className='events-slider-item__image' />
          </div>
          <div className='events-slider-item__description-container'>
            {item.area && (
              <p className='events-slider-item__area'>{item.area}</p>
            )}
            {item.title && (
              <p className='events-slider-item__title'>
                {item.title}
                <AdventureOriginalTitle
                  title={item.title}
                  originalTitle={item.originalTitle}
                />
              </p>
            )}
            {item.description && (
              <p className='events-slider-item__description'>
                {item.description}
              </p>
            )}
          </div>
        </a>
      ))}
    </Slider>
  )
}
